module.exports = __webpack_public_path__ + "static/media/customer-daawat.6601d38c.png";